import React from 'react';
import { isToday } from 'date-fns';
import { translate } from 'translations/i18n';

import {
  DatePickerWrapper,
  DatePicker,
} from 'components/shared/LocalizedDatePicker';

import { DataTestIds } from './types';

type StartDateFilterProps = {
  capturedAfter: Date;
  capturedBefore: Date;
  onChange: (arg: { capturedAfter: Date }) => void;
  dataTestIds?: DataTestIds;
  eventTracking?: () => void;
};

const StartDateFilter = ({
  capturedAfter,
  capturedBefore,
  onChange,
  dataTestIds,
  eventTracking,
}: StartDateFilterProps) => {
  return (
    <DatePickerWrapper
      // @ts-expect-error
      isSelected={capturedAfter}
      isTodaySelected={isToday(capturedAfter)}
      data-testid={dataTestIds.filterButton}
    >
      <DatePicker
        className="datepicker-input"
        id="captured_after"
        name="captured_after"
        isClearable
        fixedHeight
        popperPlacement="bottom-start"
        /**
         * shoutout to https://github.com/Hacker0x01/react-datepicker/issues/635
         * note: the react-datepickers docs for popperModifiers syntax are incorrect
         */
        popperModifiers={{
          flip: {
            enabled: false,
          },
        }}
        selected={capturedAfter}
        selectsStart
        startDate={capturedAfter}
        endDate={capturedBefore}
        placeholderText={translate(
          'assetFeed.filterRow.startDateFilter.placeholder',
        )}
        onChange={(date: Date) => {
          onChange({ capturedAfter: date });
          if (eventTracking) eventTracking();
        }}
        customInput={<input data-testid={dataTestIds.datePicker} type="text" />}
      />
    </DatePickerWrapper>
  );
};

export default StartDateFilter;
